import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { LoadingComponent } from '../widget/loading/loading.component';
import { LoadingDownloandComponent } from '../widget/loading-downloand/loading-downloand.component';

@Injectable({
  providedIn: 'root'
})
export class LoadingInterceptor {

  private loadingModal: MatDialogRef<any>;
  // Number of outstanding show()/dowloand() calls not yet matched by hide().
  // The modal only closes once every concurrent caller has called hide() —
  // without this, N parallel requests each calling show()/hide() around
  // their own HTTP call would close the modal as soon as the FIRST one
  // finishes, even though the others (and the data they carry) are still loading.
  private openCount = 0;

  constructor(private dialog: MatDialog) { }

  show() {
    if (this.openCount === 0) {
      const dialogConfig: MatDialogConfig = {
        disableClose: true,
        width: '30%',
      };

      this.loadingModal = this.dialog.open(LoadingComponent, dialogConfig);
    }
    this.openCount++;
  }

  hide() {
    if (this.openCount === 0) {
      return;
    }
    this.openCount--;
    if (this.openCount === 0 && this.loadingModal) {
      this.loadingModal.close();
      this.loadingModal = null as any;
    }
  }


  dowloand() {
    if (this.openCount === 0) {
      const dialogConfig: MatDialogConfig = {
        disableClose: true,
        width: '30%',
      };

      this.loadingModal = this.dialog.open(LoadingDownloandComponent, dialogConfig);
    }
    this.openCount++;
  }
}
